module.exports = __webpack_public_path__ + "static/media/wizualizacja-30.06b2dd3f.png";